import type { BillingInvoicePage } from '@fruitful/types';

import { buildQueryParams } from '../../common/misc';
import { requestBuilder } from '../../http/RequestBuilder';

const useGetBillingInvoices = requestBuilder.query<
    BillingInvoicePage,
    { userId: string; cursor: string | null }
>({
    endpoint: ({ cursor }) =>
        `/api/billing/invoices${buildQueryParams({
            limit: 20,
            ...(cursor != null ? { cursor } : {}),
        })}`,
    queryKey: ({ userId, cursor }) =>
        `getBillingInvoices/${userId}/${cursor ?? ''}`,
});

export default useGetBillingInvoices;
